import { render, staticRenderFns } from "./TallyDisplay.vue?vue&type=template&id=15ac3711&"
import script from "./TallyDisplay.vue?vue&type=script&lang=js&"
export * from "./TallyDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports